import { ChannelSettingSectionHeader } from './ChannelSettingSectionHeader';
import { Switch } from '@frontend/components/ui/switch';
import { CategorySelect } from '@frontend/shared/components/CategorySelect/CategorySelect';

export function ChannelDefaultCategorySection({
  isOverridden,
  value,
  onToggle,
  onValueChange,
  isReadOnly = false,
}: {
  isOverridden: boolean;
  value: string;
  onToggle: (enabled: boolean) => void;
  onValueChange: (categoryId: string) => void;
  isReadOnly?: boolean;
}) {
  return (
    <div>
      <div className="mb-3 flex items-center justify-between">
        <ChannelSettingSectionHeader
          title="Default Save Category"
          description="Override the default category when saving answers from this channel"
        />
        <Switch
          checked={isOverridden}
          disabled={isReadOnly}
          onCheckedChange={(checked) => !isReadOnly && onToggle(checked)}
        />
      </div>

      {isOverridden && (
        <div>
          <CategorySelect
            value={value}
            onChange={(categoryId) => !isReadOnly && onValueChange(categoryId)}
            isDisabled={isReadOnly}
            label=""
            placeholder="Select default category"
          />
        </div>
      )}
    </div>
  );
}
